import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import styles from './FJMobileSlider.module.less';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';

const FJMobileSlider = ({ min = 0, max = 100, value = 50, onChange, className, thumbSize = 16, disabled = false }) => {
    const [sliderValue, setSliderValue] = useState(value);
    const newValueRef = useRef(0);
    const sliderRef = useRef(null);
    const thumbRef = useRef(null);

    useEffect(() => {
        setSliderValue(value);
    }, [value]);

    const setValueInRange = useCallback(
        (e, type = 'mousedown') => {
            const slider = sliderRef.current;
            const rect = slider.getBoundingClientRect();
            newValueRef.current = e.targetTouches[0]
                ? Math.min(
                      Math.max(((e.targetTouches[0].clientX - rect.left) / rect.width) * (max - min) + min, min),
                      max,
                  )
                : newValueRef.current;
            setSliderValue(newValueRef.current);
            if (onChange) {
                onChange(newValueRef.current, type);
            }
        },
        [onChange, sliderRef.current, max, min],
    );
    const handleTouchMove = useCallback(
        e => {
            setValueInRange(e, 'mousemove');
        },
        [setValueInRange],
    );

    const _moveThrottle = useCallback(FJUtil.throttle(handleTouchMove, 10), [handleTouchMove]);

    const handleTouchEnd = useCallback(
        e => {
            setValueInRange(e, 'mouseup');
            document.removeEventListener('touchmove', _moveThrottle);
            document.removeEventListener('touchend', handleTouchEnd);
        },
        [setValueInRange],
    );

    const handleTouchStart = useCallback(
        e => {
            if (disabled) return;
            setValueInRange(e, 'mousedown');

            document.addEventListener('touchmove', _moveThrottle);
            document.addEventListener('touchend', handleTouchEnd);
        },
        [_moveThrottle, disabled],
    );

    const thumbLeft = useMemo(() => {
        return ((sliderValue - min) / (max - min)) * 100;
    }, [sliderValue, min, max]);

    return (
        <div
            className={classNames(styles.slider_box, className)}
            onTouchStart={handleTouchStart}
            // onTouchMove={handleTouchMove}
            // onTouchEnd={handleTouchEnd}
        >
            <div className={styles.slider} ref={sliderRef}>
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: `${((sliderValue - min) / (max - min)) * 100}%`,
                        height: '100%',
                        backgroundColor: 'black',
                        borderRadius: '100px',
                    }}
                />
                <div className={styles.thumb_box} style={{ width: `calc(100% - ${thumbSize - 1}px)` }}>
                    <div
                        className={styles.thumb}
                        ref={thumbRef}
                        style={{ left: `${thumbLeft}%`, width: `${thumbSize}px`, height: `${thumbSize}px` }}
                    />
                </div>
            </div>
        </div>
    );
};

export default FJMobileSlider;
